import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLocalizedPath } from '../hooks/useLocalizedPath';
import { useI18nLocaleSync } from '../hooks/useI18nLocaleSync';
import { useAppLocale } from '../hooks/useAppLocale';
import { pathWithLocale } from '../lib/locale';
import { PrivacyBodyEn, PrivacyBodyKo } from './content/TermsPrivacyBodies';

export function Privacy() {
  const { t } = useTranslation();
  const locale = useAppLocale();
  const lp = useLocalizedPath();

  useI18nLocaleSync();

  usePageMeta({
    title: locale === 'ko' ? '개인정보처리방침 – 로또 번호 생성기' : t('privacyPage.metaTitle'),
    description: locale === 'ko' ? '로또 번호 생성기 개인정보처리방침입니다.' : t('privacyPage.metaDesc'),
    path: pathWithLocale('/privacy', locale),
    noindex: locale !== 'en' && locale !== 'ko',
  });

  return (
    <main className="content">
      <nav className="breadcrumb" aria-label={t('layout.breadcrumbLabel')}>
        <Link to={lp('/')}>{t('breadcrumb.home')}</Link>
        <span className="sep">/</span>
        <span className="current">{t('nav.privacy')}</span>
      </nav>

      {locale === 'ko' ? <PrivacyBodyKo lp={lp} /> : <PrivacyBodyEn lp={lp} />}
    </main>
  );
}
